<template>
  <div id="optionInput" class="menuSection">
    <h2 class="optionTitle">{{ $t('selectDetails') }}</h2>
    <div class="optionInput oi-color">
      <div v-for="(optionValue, optionKey) in posterOptions" :key="optionKey">
        <input
          type="checkbox"
          :id="optionKey"
          :checked="posterOptions[optionKey]"
          @change="change(optionKey)"
        />
        <label :for="optionKey" class="optionLabel">
          <p class="inputName">{{ $t(`details.${optionKey}`) }}</p>
          <div class="checkbox">
            <img class="checkmark" src="../../assets/img/ic_check.svg" />
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionsInput',
  props: {
    posterOptions: Object,
  },
  methods: {
    change(optionKey) {
      this.posterOptions[optionKey] = !this.posterOptions[optionKey]
    },
  },
}
</script>
